export const getSubtitle = state => {
  let _name = state.type === 'LP'
              ? state.name
              : naturalPersonName(state)
  return _name
    ? state.document
      ? `${_name} - ${state.document}`
      : _name
    : state.document
      ? state.document
      : undefined
}
const naturalPersonName = (state) => {
  let name = ''
  if (state.name) name = state.name
  if (state.tradeName) name = (`${name} ${state.tradeName}`).trim()
  if (state.lastName) name = (`${name} ${state.lastName}`).trim()
  return name
}

export const getContractReference = state => state.contractReference

export const getCustomInvoice = state => state.customInvoice

export const isPromoterContact = state => {
  return state.source && (state.source === 'promoter')
}
export const showContactMedium = state => {
  var contactMedium = state.contactMedium
  var arr = Object.values(contactMedium)
  arr = arr.filter(x => x !== undefined && x !== null)
  return arr.length > 0
}

export const apificate = (state, getters) => {
  let {
    type,
    residence,
    tradeName,
    name,
    lastName,
    document,
    additionalInfo,
    contractReference,
    mercantileRegistry
  } = state
  let {
    street,
    postalCode,
    town,
    city,
    country
  } = state.address
  /* let {
    operationNumber,
    serviceType
  } = state.additionalInfo */
  let contactMedium = getters['contactMedium/apificate']
  // if (!state.hasContactMedium) contactMedium = Object.keys(contactMedium).reduce((acc, x) => ({ ...acc, [x]: null }), {})
  contractReference = state.hasContractReference ? contractReference : null
  return {
    type,
    residence,
    tradeName,
    name,
    lastName,
    document,
    contractReference,
    mercantileRegistry,
    address: {
      street,
      postalCode,
      town,
      city,
      country
    },
    additionalInfo,
    contactMedium,
    FACeB2B: getters['FACeB2B/apificate'],
    accountingOffice: getters['accountingOffice/apificate'],
    managerBody: getters['managerBody/apificate'],
    processingUnit: getters['processingUnit/apificate'],
    proponentBody: getters['proponentBody/apificate']
  }
}

export const visualize = state => {
  let {
    type,
    residence,
    tradeName,
    name,
    lastName,
    document
  } = state
  let {
    street,
    postalCode,
    town,
    city,
    country
  } = state.address
  return {
    type,
    residence,
    tradeName,
    name,
    lastName,
    document,
    street,
    postalCode,
    town,
    city,
    country
  }
}

export const getValue = state => (key) => {
  return state.rawadditionalInfo[key]
}

export const loaded = (state) => {
  return state.loaded
}

export const getDocumentAndName = state => {
  let {
    name,
    document
  } = state
  return {
    name,
    document
  }
}

export const dirType = (state) => {
  return state.dirType
}
